import React from "react";
import { Button } from "./ui/button";
import { FileText } from "lucide-react";

const Rules = () => {
  return (
    <Button
      type="button"
      variant="link"
      size="sm"
      className="gap-1.5 text-secondary h-auto p-0 text-xs"
      onClick={() => window.open("https://imagigeeks.org/assets/Règlement.pdf", "_blank")}
    >
      <FileText className="h-3.5 w-3.5" />
      Voir le règlement
    </Button>
  );
};

export default Rules;
